/**
 * Validates an address input by allowing only:
 * - Letters from all languages (A-Z, ä, ñ, 北京, دبي, etc.)
 * - Diacritics (é, ü, ñ, etc.)
 * - Numbers (0-9)
 * - Spaces
 * - Common address punctuation: , . ' ’ - (comma, period, apostrophe, dash)
 *
 * @param input - The user input string.
 * @returns A sanitized string with only valid characters.
 */
export const sanitizeAddressInput = (input) => {
    // Normalize different hyphen variants to a standard hyphen (-)
    const normalizedHyphens = input.replace(/[\u2010-\u2015\u2043\uFE63]/g, '-');
    // Allow:
    // - Letters from all languages (\p{L})
    // - Diacritics (é, ü, ñ, etc.) (\p{M})
    // - Numbers (0-9) (\p{N})
    // - Spaces (\s)
    // - Common address punctuation: , . ' ’ - # & ( ) / : 〒 、 。 ！ ？ ： ；
    const validPattern = /[^\p{L}\p{M}\p{N}\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\s\p{Zs},.'’\-#&()@/:〒、。：；]/gu;
    return normalizedHyphens.replace(validPattern, '');
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGlvbkhlbHBlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbC92YWxpZGF0aW9uSGVscGVycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7OztHQVVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxLQUFhLEVBQVUsRUFBRTtJQUMxRCwrREFBK0Q7SUFDL0QsTUFBTSxpQkFBaUIsR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLDhCQUE4QixFQUFFLEdBQUcsQ0FBQyxDQUFDO0lBRTdFLFNBQVM7SUFDVCx1Q0FBdUM7SUFDdkMsdUNBQXVDO0lBQ3ZDLDBCQUEwQjtJQUMxQixnQkFBZ0I7SUFDaEIsb0VBQW9FO0lBQ3BFLE1BQU0sWUFBWSxHQUNkLG9HQUFvRyxDQUFDO0lBQ3pHLE9BQU8saUJBQWlCLENBQUMsT0FBTyxDQUFDLFlBQVksRUFBRSxFQUFFLENBQUMsQ0FBQztBQUN2RCxDQUFDLENBQUMifQ==